import React, { useState } from "react";
import { Typography, Tabs, Space, Flex,} from "antd";
import DashboardLayout from "../../layout/dashboardLayout/DashboardLayout";
import Overview from "./Overview";
import Leaderboard from "./Leaderboard";
import "./style.css"
import MyProgress from "./MyProgress";

const { Title, Text } = Typography;


const TargetsAndRewards = () => {

  const [tab, setTab] = useState("1");


  return (
    <DashboardLayout >
      <div style={{ padding: 30, maxWidth: 1920,}}>
        {/* Header */}
        <Title level={2} style={{ marginBottom: 8}} className="page-title">
          Targets & Rewards
        </Title>
        <Text type="secondary">
          Set goals, track performance, and motivate your team with achievements
        </Text>

        {/* Tabs */}
        <Tabs
          className="custom-tabs"
          defaultActiveKey="1"
          style={{ marginTop: 24, fontWeight: 500 }}
          items={[
            { key: "1", label: "Overview" },
            { key: "2", label: "Leaderboard" },
            { key: "3", label: "My Progress" },
          ]}
          onChange={(key) => setTab(key)}
        />

        {tab === "1" && <Overview/>}
        {tab === "2" && <Leaderboard/>}
        {tab === "3" && <MyProgress/>}
      </div>
    </DashboardLayout>
  );
};

export default TargetsAndRewards;
